import { css } from '@emotion/react'
import { BREAKPOINTS } from 'utils/styled'
import { Icon } from 'components/icon'
import { colors } from 'utils/colors'
import { useTranslation } from 'next-i18next'

export function WizardSearchField(props: {
  showWarning?: boolean
  value?: string
  onChange?: (value: string) => void
  className?: string
}) {
  const { t } = useTranslation('device')
  return (
    <label
      className={props.className}
      css={css`
        width: 40%;
        box-shadow: var(--card-shadow);
        border-radius: 2px;
        display: flex;
        align-items: stretch;
        height: 54px;
        margin-bottom: 28px;
        background: #fff;
        overflow: hidden;

        @media ${BREAKPOINTS.MD.max} {
          width: 100%;
        }
      `}
    >
      <button
        css={css`
          display: flex;
          flex-basis: 54px;
          flex-shrink: 0;

          align-items: center;
          justify-content: center;

          background: none;
          border: none;
          outline: none;
        `}
      >
        <Icon name="Search" color={colors.blue[500]} />
      </button>
      <div
        css={css`
          position: relative;
          width: 100%;
          display: flex;
        `}
      >
        <input
          value={props.value}
          onChange={(e) => props.onChange?.(e.target.value)}
          type="text"
          name="search"
          placeholder={t('device.document_add.document_type_search_placeholder')}
          css={css`
            border: none;
            outline: none;

            font-family: var(--f-text);
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 27px;
            flex-grow: 1;
          `}
        />
        {props.showWarning && props.value && (
          <div
            css={css`
              position: absolute;
              top: 20px;
              right: 20px;
            `}
          >
            <Icon name="Warning" size={16} color={colors.red[500]} />
          </div>
        )}
      </div>
    </label>
  )
}
